Object.defineProperty(exports,"__esModule",{value:true});exports.getToday=void 0;var _UTC=require("./UTC");var getToday=function getToday(){return(0,_UTC.UTC)(new Date());};exports.getToday=getToday;
//# sourceMappingURL=getToday.js.map